import {BottomTabBar} from '@react-navigation/bottom-tabs';
import React, {useContext, useEffect, useState} from 'react';
import {Animated} from 'react-native';
import AudioPlayer from '../../components/audio-player/AudioPlayer';
import DataContext from '../../context/dataContext';
import {useTheme} from '../../theme/ThemeContext';
import {getTabBarSlideOffset} from '../../theme/tabBarStyles';
import {IS_MOBILE} from '../../utils/platform';

const CustomBottomTabBar = props => {
  const {hideTabBar} = useContext(DataContext);
  const {theme} = useTheme();
  const slide = getTabBarSlideOffset(theme);
  const [animation] = useState(new Animated.Value(0));

  const translateY = animation.interpolate({
    inputRange: [0, slide],
    outputRange: [slide, 0],
  });

  useEffect(() => {
    Animated.timing(animation, {
      toValue: hideTabBar ? 0 : slide,
      duration: 200,
      useNativeDriver: true,
    }).start();
  }, [hideTabBar, slide, animation]);

  return (
    <Animated.View
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        overflow: 'visible',
        transform: [{translateY}],
      }}>
      {IS_MOBILE && <AudioPlayer />}
      <BottomTabBar {...props} style={{position: 'relative'}} />
    </Animated.View>
  );
};

export default CustomBottomTabBar;
